import { apiTechpack } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { zEntity, ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";
import { zTechpackSettings, ZTechpackSettings } from "./TechpackTypes";

export const loadTechpackSettings = async (
  id: ZUid,
): Promise<ZTechpackSettings> => {
  const resp = await rest.get(apiTechpack(`/settings/${id}`));
  return zTechpackSettings.parse(resp.data);
};

export const saveTechpackSettings = async (
  id: ZUid,
  settings: ZTechpackSettings,
) => {
  await rest.post(apiTechpack(`/settings/${id}`), settings);
};

export const createTechpackInstance = async (
  entity: ZEntity,
  objectServiceId: ZUid,
): Promise<ZEntity> => {
  const { id, ...other } = entity;
  const resp = await rest.post(
    apiTechpack(`/techpack/${objectServiceId}`),
    other,
  );
  return zEntity.parse(resp.data);
};
